import React,{useEffect} from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/navbar";
import BrandLogo from "../components/brandLogo";
import AboutThree from "../components/aboutThree";
import Features from "../components/features";
import AboutOne from "../components/aboutOne";
import AboutTwo from "../components/aboutTwo";
import AiFeatures from "../components/aiFeatures";
import Pricing from "../components/pricing";
import Clients from "../components/clients";
import Blogs from "../components/blogs";
import Footer from "../components/footer";
import Switcher from "../components/switcher";

export default function IndexThree(){
    useEffect(() => {
        document.documentElement.setAttribute("dir", "ltr");
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
      }, []);
    return(
        <>
        <Navbar/>
            <section className="relative md:py-48 py-36 items-center mt-[74px] md:mx-4 md:rounded-3xl overflow-hidden">
                <div className="absolute top-0 start-0 w-full h-full z-0 pointer-events-none overflow-hidden">
                    <iframe
                        src="https://www.youtube.com/embed/jvzfWpaL9fI?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1&playlist=jvzfWpaL9fI"
                        title="my-fram"
                        className="absolute top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 w-screen h-[56.25vw] min-h-screen md:min-w-[177.77vw] min-w-[400vw]">
                    </iframe>
                </div>

                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent"></div>
                <div className="container relative">
                    <div className="grid grid-cols-1 text-center">
                        <div className="">
                            <h4 className="font-bold lg:leading-normal leading-normal text-white text-4xl lg:text-7xl mb-5">Explore novas fronteiras<br/>da tecnologia
                            </h4>
                            <p className="text-white/70 text-lg max-w-xl mx-auto">Nós introduzimos inovação e tecnologia de ponta nas empresas, tornando mais simples a rotina das empresas.</p>

                            <div className="mt-6">
                                <Link to=""
                                      className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400 hover:bg-amber-500 border-amber-400 hover:border-amber-500 text-white rounded-md">
                                    Saiba mais</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="pt-6">
                <BrandLogo/>
            </section>

            <section className="relative md:pb-24 pb-16">
                <AboutThree/>
                <AiFeatures/>

                <AboutOne/>
                <AboutTwo/>
                <Blogs/>
        </section>
        <Footer/>
        <Switcher/>
        </>
    )
}